import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cloak-page2',
  templateUrl: './cloak-page2.component.html',
  styleUrls: ['./cloak-page2.component.css']
})
export class CloakPage2Component implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/3']);
    }, 300); // redirect after 1 second
  }

}
